import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_BehaviorDataSheet = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_BehaviorDataSheet' className='file-pdf-document'>
            <div className='file-template'>

                <h3>BEHAVIOR DATA SHEET
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span>
                            <input type='text' name='txtName' id='txtName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Week Of:</span>
                            <input type='text' name='txtWeek' id='txtWeek' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Behaviors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-15'>1.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors1' id='txtBehaviors1' className='add-only' />
                        </td>
                        <td className='w-15'>4.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors2' id='txtBehaviors2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-15'>2.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors3' id='txtBehaviors3' className='add-only' />
                        </td>
                        <td className='w-15'>5.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors4' id='txtBehaviors4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-15'>3.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors5' id='txtBehaviors5' className='add-only' />
                        </td>
                        <td className='w-15'>6.</td>
                        <td className='w-360'>
                            <input type='text' name='txtBehaviors6' id='txtBehaviors6' className='add-only' />
                        </td>
                    </tr>
                </table>
                
                <p className='w-750'><hr /></p>
                
                <p className='w-750'>
                    <b>Note:-</b> Enter code of Most restrictive method used Enter an 'X' if no behaviors occur Circle the behavior # if no multiple incidents
                </p>

                <p className='w-750'><hr /></p>

                <table>
                    <tr>
                        <td className='w-375'>V = Verbal Prompt</td>
                        <td className='w-375'>T = Time Out</td>
                    </tr>
                    <tr>
                        <td className='w-375'>G = Gesture</td>
                        <td className='w-375'>TH = Therapeutic Hold</td>
                    </tr>
                    <tr>
                        <td className='w-375'>P = Partial Physical</td>
                        <td className='w-375'>R = Redirect</td>
                    </tr>
                    <tr>
                        <td className='w-375'>C = Correction</td>
                        <td className='w-375'>O = Other</td>
                    </tr>
                    <tr>
                        <td className='w-375'>F = Full Partial</td>
                        <td className='w-375'></td>
                    </tr>
                    <tr>
                        <td className='w-375'>B = Walking Belt</td>
                        <td className='w-375'></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-75'>
                            <span className='eleHeader'>Dates</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>MON</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>TUES</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>WED</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>THUR</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>FRI</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>SAT</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>SUN</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Behavior Codes</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>Time</b>
                        </td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-75'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-75'><b>1:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_1' id='txtUpdateMon_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_1' id='txtUpdateTues_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_1' id='txtUpdateWed_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_1' id='txtUpdateThur_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_1' id='txtUpdateFri_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_1' id='txtUpdateSat_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_1' id='txtUpdateSun_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_1' id='txtUpdateBehv_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>1:30 AM</b> </td>

                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_2' id='txtUpdateMon_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_2' id='txtUpdateTues_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_2' id='txtUpdateWed_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_2' id='txtUpdateThur_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_2' id='txtUpdateFri_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_2' id='txtUpdateSat_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_2' id='txtUpdateSun_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_2' id='txtUpdateBehv_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>2:00 AM</b> </td>

                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_3' id='txtUpdateMon_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_3' id='txtUpdateTues_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_3' id='txtUpdateWed_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_3' id='txtUpdateThur_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_3' id='txtUpdateFri_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_3' id='txtUpdateSat_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_3' id='txtUpdateSun_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_3' id='txtUpdateBehv_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>2:30 AM</b> </td>

                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_4' id='txtUpdateMon_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_4' id='txtUpdateTues_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_4' id='txtUpdateWed_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_4' id='txtUpdateThur_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_4' id='txtUpdateFri_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_4' id='txtUpdateSat_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_4' id='txtUpdateSun_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_4' id='txtUpdateBehv_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>3:00 AM</b> </td>
                        
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_5' id='txtUpdateMon_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_5' id='txtUpdateTues_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_5' id='txtUpdateWed_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_5' id='txtUpdateThur_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_5' id='txtUpdateFri_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_5' id='txtUpdateSat_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_5' id='txtUpdateSun_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_5' id='txtUpdateBehv_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>3:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_6' id='txtUpdateMon_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_6' id='txtUpdateTues_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_6' id='txtUpdateWed_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_6' id='txtUpdateThur_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_6' id='txtUpdateFri_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_6' id='txtUpdateSat_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_6' id='txtUpdateSun_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_6' id='txtUpdateBehv_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>4:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_7' id='txtUpdateMon_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_7' id='txtUpdateTues_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_7' id='txtUpdateWed_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_7' id='txtUpdateThur_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_7' id='txtUpdateFri_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_7' id='txtUpdateSat_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_7' id='txtUpdateSun_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_7' id='txtUpdateBehv_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>4:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_8' id='txtUpdateMon_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_8' id='txtUpdateTues_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_8' id='txtUpdateWed_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_8' id='txtUpdateThur_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_8' id='txtUpdateFri_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_8' id='txtUpdateSat_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_8' id='txtUpdateSun_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_8' id='txtUpdateBehv_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>5:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_9' id='txtUpdateMon_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_9' id='txtUpdateTues_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_9' id='txtUpdateWed_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_9' id='txtUpdateThur_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_9' id='txtUpdateFri_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_9' id='txtUpdateSat_9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_9' id='txtUpdateSun_9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_9' id='txtUpdateBehv_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>5:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_10' id='txtUpdateMon_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_10' id='txtUpdateTues_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_10' id='txtUpdateWed_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_10' id='txtUpdateThur_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_10' id='txtUpdateFri_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_10' id='txtUpdateSat_10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_10' id='txtUpdateSun_10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_10' id='txtUpdateBehv_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>6:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_11' id='txtUpdateMon_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_11' id='txtUpdateTues_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_11' id='txtUpdateWed_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_11' id='txtUpdateThur_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_11' id='txtUpdateFri_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_11' id='txtUpdateSat_11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_11' id='txtUpdateSun_11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_11' id='txtUpdateBehv_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>6:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_12' id='txtUpdateMon_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_12' id='txtUpdateTues_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_12' id='txtUpdateWed_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_12' id='txtUpdateThur_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_12' id='txtUpdateFri_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_12' id='txtUpdateSat_12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_12' id='txtUpdateSun_12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_12' id='txtUpdateBehv_12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>7:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_13' id='txtUpdateMon_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_13' id='txtUpdateTues_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_13' id='txtUpdateWed_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_13' id='txtUpdateThur_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_13' id='txtUpdateFri_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_13' id='txtUpdateSat_13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_13' id='txtUpdateSun_13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_13' id='txtUpdateBehv_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>7:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_14' id='txtUpdateMon_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_14' id='txtUpdateTues_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_14' id='txtUpdateWed_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_14' id='txtUpdateThur_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_14' id='txtUpdateFri_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_14' id='txtUpdateSat_14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_14' id='txtUpdateSun_14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_14' id='txtUpdateBehv_14' className='add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-75'>
                            <b>8:00 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon18' id='txtMon' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues18' id='txtTues18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed18' id='txtWed18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur18' id='txtThur18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri18' id='txtFri18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat18' id='txtSat18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun18' id='txtSun18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv18' id='txtBehv18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>8:30 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon17' id='txtMon17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues17' id='txtTues17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed17' id='txtWed17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur17' id='txtThur17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri17' id='txtFri17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat17' id='txtSat17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun17' id='txtSun17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv17' id='txtBehv17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>9:00 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon16' id='txtMon16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues16' id='txtTues16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed16' id='txtWed16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur16' id='txtThur16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri16' id='txtFri16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat16' id='txtSat16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun16' id='txtSun16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv16' id='txtBehv16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>9:30 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon15' id='txtMon15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues15' id='txtTues15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed15' id='txtWed15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur15' id='txtThur15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri15' id='txtFri15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat15' id='txtSat15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun15' id='txtSun15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv15' id='txtBehv15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>10:00 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon14' id='txtMon14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues14' id='txtTues14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed14' id='txtWed14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur14' id='txtThur14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri14' id='txtFri14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat14' id='txtSat14' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun14' id='txtSun14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv14' id='txtBehv14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>10:30 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon13' id='txtMon13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues13' id='txtTues13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed13' id='txtWed13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur13' id='txtThur13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri13' id='txtFri13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat13' id='txtSat13' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun13' id='txtSun13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv13' id='txtBehv13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>11:00 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon12' id='txtMon12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues12' id='txtTues12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed12' id='txtWed1212' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur12' id='txtThur12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri12' id='txtFri12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat12' id='txtSat12' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun12' id='txtSun12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv12' id='txtBehv12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>11:30 AM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon11' id='txtMon11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues11' id='txtTues11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed11' id='txtWed11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur11' id='txtThur11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri11' id='txtFri11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat11' id='txtSat11' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun11' id='txtSun11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv11' id='txtBehv11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>12:00 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon10' id='txtMon10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues10' id='txtTues10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed10' id='txtWed10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur10' id='txtThur10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri10' id='txtFri10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat10' id='txtSat10' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun10' id='txtSun10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv10' id='txtBehv10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>12:30 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon9' id='txtMon9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues9' id='txtTues9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed9' id='txtWed9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur9' id='txtThur9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri9' id='txtFri9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat9' id='txtSat9' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun9' id='txtSun9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv9' id='txtBehv9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>1:00 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon8' id='txtMon8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues8' id='txtTues8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed8' id='txtWed8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur8' id='txtThur8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri8' id='txtFri8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat8' id='txtSat8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun8' id='txtSun8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv8' id='txtBehv8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>1:30 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon7' id='txtMon7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues7' id='txtTues7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed7' id='txtWed7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur7' id='txtThur7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri7' id='txtFri7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat7' id='txtSat7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun7' id='txtSun7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv7' id='txtBehv7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>2:00 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon6' id='txtMon6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues6' id='txtTues6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed6' id='txtWed6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur6' id='txtThur6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri6' id='txtFri6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat6' id='txtSat6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun6' id='txtSun6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv6' id='txtBehv6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>2:30 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon5' id='txtMon5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues5' id='txtTues5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed5' id='txtWed5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur5' id='txtThur5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri5' id='txtFri5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat5' id='txtSat5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun5' id='txtSun5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv5' id='txtBehv5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>3:00 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon4' id='txtMon4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues4' id='txtTues4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed4' id='txtWed4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur4' id='txtThur4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri4' id='txtFri4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat4' id='txtSat4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun' id='txtSun4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv4' id='txtBehv4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>3:30 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon3' id='txtMon3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues3' id='txtTues3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed3' id='txtWed3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur3' id='txtThur3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri3' id='txtFri3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat3' id='txtSat3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun3' id='txtSun3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv3' id='txtBehv3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'>
                            <b>4:00 PM</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon2' id='txtMon2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues2' id='txtTues2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed2' id='txtWed2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur2' id='txtThur2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri2' id='txtFri2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat2' id='txtSat2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun2' id='txtSun2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv2' id='txtBehv2' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-75'><b>4:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_15' id='txtUpdateMon_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_15' id='txtUpdateTues_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_15' id='txtUpdateWed_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_15' id='txtUpdateThur_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_15' id='txtUpdateFri_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_15' id='txtUpdateSat_15' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_15' id='txtUpdateSun_15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_15' id='txtUpdateBehv_15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>5:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_16' id='txtUpdateMon_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_16' id='txtUpdateTues_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_16' id='txtUpdateWed_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_16' id='txtUpdateThur_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_16' id='txtUpdateFri_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_16' id='txtUpdateSat_16' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_16' id='txtUpdateSun_16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_16' id='txtUpdateBehv_16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>5:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_17' id='txtUpdateMon_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_17' id='txtUpdateTues_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_17' id='txtUpdateWed_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_17' id='txtUpdateThur_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_17' id='txtUpdateFri_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_17' id='txtUpdateSat_17' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_17' id='txtUpdateSun_17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_17' id='txtUpdateBehv_17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>6:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_18' id='txtUpdateMon_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_18' id='txtUpdateTues_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_18' id='txtUpdateWed_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_18' id='txtUpdateThur_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_18' id='txtUpdateFri_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_18' id='txtUpdateSat_18' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_18' id='txtUpdateSun_18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_18' id='txtUpdateBehv_18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>6:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_19' id='txtUpdateMon_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_19' id='txtUpdateTues_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_19' id='txtUpdateWed_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_19' id='txtUpdateThur_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_19' id='txtUpdateFri_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_19' id='txtUpdateSat_19' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_19' id='txtUpdateSun_19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_19' id='txtUpdateBehv_19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>7:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_20' id='txtUpdateMon_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_20' id='txtUpdateTues_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_20' id='txtUpdateWed_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_20' id='txtUpdateThur_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_20' id='txtUpdateFri_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_20' id='txtUpdateSat_20' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_20' id='txtUpdateSun_20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_20' id='txtUpdateBehv_20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>7:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_21' id='txtUpdateMon_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_21' id='txtUpdateTues_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_21' id='txtUpdateWed_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_21' id='txtUpdateThur_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_21' id='txtUpdateFri_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_21' id='txtUpdateSat_21' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_21' id='txtUpdateSun_21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_21' id='txtUpdateBehv_21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>8:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_22' id='txtUpdateMon_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_22' id='txtUpdateTues_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_22' id='txtUpdateWed_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_22' id='txtUpdateThur_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_22' id='txtUpdateFri_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_22' id='txtUpdateSat_22' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_22' id='txtUpdateSun_22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_22' id='txtUpdateBehv_22' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>8:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_23' id='txtUpdateMon_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_23' id='txtUpdateTues_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_23' id='txtUpdateWed_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_23' id='txtUpdateThur_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_23' id='txtUpdateFri_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_23' id='txtUpdateSat_23' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_23' id='txtUpdateSun_23' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_23' id='txtUpdateBehv_23' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>9:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_24' id='txtUpdateMon_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_24' id='txtUpdateTues_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_24' id='txtUpdateWed_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_24' id='txtUpdateThur_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_24' id='txtUpdateFri_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_24' id='txtUpdateSat_24' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_24' id='txtUpdateSun_24' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_24' id='txtUpdateBehv_24' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>9:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_25' id='txtUpdateMon_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_25' id='txtUpdateTues_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_25' id='txtUpdateWed_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_25' id='txtUpdateThur_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_25' id='txtUpdateFri_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_25' id='txtUpdateSat_25' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_25' id='txtUpdateSun_25' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_25' id='txtUpdateBehv_25' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>10:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_26' id='txtUpdateMon_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_26' id='txtUpdateTues_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_26' id='txtUpdateWed_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_26' id='txtUpdateThur_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_26' id='txtUpdateFri_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_26' id='txtUpdateSat_26' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_26' id='txtUpdateSun_26' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_26' id='txtUpdateBehv_26' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>10:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_27' id='txtUpdateMon_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_27' id='txtUpdateTues_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_27' id='txtUpdateWed_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_27' id='txtUpdateThur_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_27' id='txtUpdateFri_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_27' id='txtUpdateSat_27' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_27' id='txtUpdateSun_27' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_27' id='txtUpdateBehv_27' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>11:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_28' id='txtUpdateMon_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_28' id='txtUpdateTues_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_28' id='txtUpdateWed_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_28' id='txtUpdateThur_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_28' id='txtUpdateFri_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_28' id='txtUpdateSat_28' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_28' id='txtUpdateSun_28' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_28' id='txtUpdateBehv_28' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>11:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_29' id='txtUpdateMon_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_29' id='txtUpdateTues_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_29' id='txtUpdateWed_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_29' id='txtUpdateThur_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_29' id='txtUpdateFri_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_29' id='txtUpdateSat_29' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_29' id='txtUpdateSun_29' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_29' id='txtUpdateBehv_29' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>12:00 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_30' id='txtUpdateMon_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_30' id='txtUpdateTues_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_30' id='txtUpdateWed_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_30' id='txtUpdateThur_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_30' id='txtUpdateFri_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_30' id='txtUpdateSat_30' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_30' id='txtUpdateSun_30' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_30' id='txtUpdateBehv_30' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><b>12:30 AM</b> </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateMon_31' id='txtUpdateMon_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateTues_31' id='txtUpdateTues_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateWed_31' id='txtUpdateWed_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateThur_31' id='txtUpdateThur_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateFri_31' id='txtUpdateFri_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSat_31' id='txtUpdateSat_31' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtUpdateSun_31' id='txtUpdateSun_31' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtUpdateBehv_31' id='txtUpdateBehv_31' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-75'>
                            <b>INITIALS</b>
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtMon1' id='txtMon1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtTues1' id='txtTues1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtWed1' id='txtWed1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtThur1' id='txtThur1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtFri1' id='txtFri1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSat1' id='txtSat1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' name='txtSun1' id='txtSun1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtBehv1' id='txtBehv1' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                    </tr>
                    <tr>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                    </tr>
                    <tr>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                    </tr>
                    <tr>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                    </tr>
                    <tr>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                        <td className='small w-200'>SIGNATURES</td>
                        <td className='small w-175'>INITIALS</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











